var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7187_8824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.13623 15.6227V15.1227H5.63623H2.26123C1.29636 15.1227 0.51123 14.3376 0.51123 13.3727V3.24768C0.51123 2.28281 1.29636 1.49768 2.26123 1.49768H15.7612C16.7261 1.49768 17.5112 2.28281 17.5112 3.24768V13.3727C17.5112 14.3376 16.7261 15.1227 15.7612 15.1227H10.6987H10.532L10.3987 15.2227L6.13623 18.4204V15.6227Z",
    stroke: "#D3D3D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7187_8824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.0112305 0.997681)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.6005bd92cee8a1c7ac4d8e94c20deb21.svg";
export { ForwardRef as ReactComponent };